package link.erpango.quip.core.auth.google

import androidx.compose.runtime.Composable
import kotlinx.coroutines.suspendCancellableCoroutine
import link.erpango.quip.GOOGLE_WEB_CLIENT_ID
import link.erpango.quip.core.auth.entities.GoogleUser
import kotlin.coroutines.resume
import org.w3c.dom.HTMLElement

class GoogleAuthProviderImpl : GoogleAuthProvider {
    @Composable
    override fun getUiProvider(): GoogleAuthUiProvider {
        return GoogleAuthUiProviderImpl()
    }

    override suspend fun signOut() {
        console.log("GoogleAuthProviderImpl: signOut")
        google.accounts.id.disableAutoSelect()
    }
}

class GoogleAuthUiProviderImpl : GoogleAuthUiProvider {
    override suspend fun signIn(): GoogleUser? = suspendCancellableCoroutine { continuation ->
        val callback = { response: CredentialResponse ->
            val idToken = response.credential
            console.log("Google Sign-In successful. Token length: ${idToken.length}")
            
            // Decodificar JWT para obtener info básica (opcional, pero buena práctica para rellenar GoogleUser)
            // Por ahora devolvemos el token y un usuario genérico, o parseamos el payload si tenemos utilidades.
            // Para simplificar, usaremos el token.
            
            val user = GoogleUser(
                idToken = idToken,
                displayName = "Google User", // TODO: Extract from JWT
                profilePicUrl = null // TODO: Extract from JWT
            )
            continuation.resume(user)
        }

        val config = js("{}").unsafeCast<GoogleIdConfiguration>()
        config.client_id = GOOGLE_WEB_CLIENT_ID
        config.callback = callback
        config.auto_select = false
        config.use_fedcm_for_prompt = js("window.env.USE_FEDCM === true || window.env.USE_FEDCM === 'true'") as Boolean

        google.accounts.id.initialize(config)
        
        // Mostrar el prompt One Tap o el botón si lo tuviéramos renderizado
        // Aquí forzamos el prompt
        google.accounts.id.prompt { notification ->
            if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
                console.log("Google Sign-In prompt not displayed or skipped: ${notification.getNotDisplayedReason()} / ${notification.getSkippedReason()}")
                // Si el prompt falla o se cierra, podríamos querer reanudar con null
                // continuation.resume(null) // Cuidado con llamar resume dos veces si el callback salta después
            }
        }
    }
}


// External declarations for Google Identity Services

// ... (existing imports)

// ...

// External declarations for Google Identity Services
external object google {
    object accounts {
        object id {
            fun initialize(config: GoogleIdConfiguration)
            fun prompt(notification: (PromptMomentNotification) -> Unit = definedExternally)
            fun disableAutoSelect()
            fun renderButton(parent: HTMLElement, options: dynamic)
        }
    }
}

external interface GoogleIdConfiguration {
    var client_id: String
    var callback: (CredentialResponse) -> Unit
    var auto_select: Boolean?
    var cancel_on_tap_outside: Boolean?
    var use_fedcm_for_prompt: Boolean?
}

external interface CredentialResponse {
    val credential: String
    val select_by: String
}

external interface PromptMomentNotification {
    fun isDisplayMoment(): Boolean
    fun isDisplayed(): Boolean
    fun isNotDisplayed(): Boolean
    fun getNotDisplayedReason(): String
    fun isSkippedMoment(): Boolean
    fun getSkippedReason(): String
    fun isDismissedMoment(): Boolean
    fun getDismissedReason(): String
    fun getMomentType(): String
}
